import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    // data: [],
};

const delegateDepositReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.value,
    }),
    [type.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
    [type.DROPDOWN]: (state, action) => ({
        ...state,
        dropDown: action.value,
    }),
    
    [type.INIT_DELEGATE_DEPOSIT_INITIAL_LOADING]: (state, action) => ({
        ...state,
        delegate_deposit_initial_loading: action.payload
    }),
    [type.SET_DELEGATE_DEPOSIT_INITIAL_LOADING]: (state, action) => ({
        ...state,
        delegate_deposit_initial_loading: [...state.delegate_deposit_initial_loading.map((item) => (item.id === action.page) ? {...item, loading: false} : item)]
    }),

    [type.SET_DELEGATE_DEPOSIT_QUOTA_LOCAL_STATE]: (state, action) => ({
        ...state,
        delegate_deposit_quota_local_state: action.payload
    }),

    [type.SET_DELEGATE_DEPOSIT_HISTORY_LOCAL_STATE]: (state, action) => ({
        ...state,
        delegate_deposit_history_local_state: action.payload
    }),

    [type.CURRENCY_EXCHANGE]: (state, action) => ({
        ...state,
        currency_exchange: action.payload
    })
});

export default delegateDepositReducer;